<template>
    <div id="caseSearch">
        <div>
            <p>全部案例</p>
            <div id="caseList">
                <!-- 分类 -->
                <el-tabs v-model="activeName">
                    <el-tab-pane name="1">
                        <div slot="label" @click="mySearch('全部')">全部</div>
                    </el-tab-pane>
                    <el-tab-pane name="2">
                        <div slot="label" @click="mySearch('国家')">国家专项/课题</div>
                    </el-tab-pane>
                    <el-tab-pane name="3">
                        <div slot="label" @click="mySearch('河北')">河北</div>
                    </el-tab-pane>
                    <el-tab-pane name="4">
                        <div slot="label" @click="mySearch('天津')">天津</div>
                    </el-tab-pane>
                    <el-tab-pane name="5">
                        <div slot="label" @click="mySearch('山东')">山东</div>
                    </el-tab-pane>
                    <el-tab-pane name="6">
                        <div slot="label" @click="mySearch('辽宁')">辽宁</div>
                    </el-tab-pane>
                    <el-tab-pane name="7">
                        <div slot="label" @click="mySearch('黑龙江')">黑龙江</div>
                    </el-tab-pane>
                    <el-tab-pane name="8">
                        <div slot="label" @click="mySearch('其它')">……</div>
                    </el-tab-pane>
                </el-tabs>
                <!-- 分类展示 -->
                <div id="caseWapper">
                    <ul>
                        <li v-for="(item,key) in caseShwo" :key="key">
                            <i class="el-icon-s-help itemIco"></i>{{item.value}}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {case_data} from '@/assets/js/case.js'
// 引入data.js 文件
const caseList = {
    case_data
}
export default {
    name: 'Screen4',
    data(){
        return{
            caseCont:[], //json数据暂存
            caseShwo:[],//分类筛选的数据
            word:"",//分类关键字
            activeName: '1'
        }
    },
    methods: {
        //分类筛选
        mySearch(key) {
            this.word = key; 
            this.caseShwo = this.caseCont.filter(this.searchCondition); //这里调用方法时不能用括号调用
        },
        // 筛选条件
        searchCondition(arr) {
            if(this.word == "全部"){
                return arr;
            }else{
                return arr.keyWord == this.word;
            }
        },
    },
    mounted(){
        this.caseCont = caseList.case_data;
        this.mySearch("全部");
    }
}
</script>

<style scoped>
    #caseSearch{
        margin-top: 30px;
        background: #f3f3f5;
        padding-bottom:30px; 
    }
    #caseSearch>div{
        margin: 0 auto;
        width: 1120px;
        padding-top: 30px;
    }
    #caseSearch>div>p{
        text-align: center;
        font-size: 18px;
        padding-bottom: 30px;
    }
    #caseWapper{
        padding: 20px 40px;
        border: 1px solid #ddd;
        background: #fff;
    }
    #caseWapper>ul{
        height: 660px;
        overflow-y: auto;
    }
    #caseWapper>ul>li{
        cursor: default;
        line-height: 32px;
    }
    .itemIco{
        margin-right: 10px;
    }
</style>
